<h1 class="emps-title">Finish setting up in {{ steps.length }} steps.</h1>
<div class="emps-layout">
  <div class="emps-layout-aside">
    <progress-stepper
      [steps]="steps"
      [currentStep]="currentStep"
    ></progress-stepper>
  </div>
  <div class="emps-layout-main">
    <div class="emps-layout-current-step" *ngIf="serviceProvider">
      <ng-container [ngSwitch]="currentStep">
        <external-mam-providers-setup-step-one
          *ngSwitchCase="steps[0]"
          [loginData]="gatewayProvider.additionalData.loginData"
          [loginOk]="gatewayProvider.additionalData.general.connectingTested"
          [serviceName]="serviceProvider.name"
          [gatewayName]="gatewayProvider.additionalData.general.name"
          [autoPull]="gatewayProvider.additionalData.general.autoPull"
          [isActive]="gatewayProvider.isActive"
          [languages]="systemLanguages"
          [providerType]="gatewayProvider.externalMAMType"
          [dropBucket]="gatewayProvider.additionalData.dropBucket"
          [selectedLanguages]="
            rebuildSelectedLanguages(gatewayProvider.additionalData.languages)
          "
          [selectedSubtitles]="
            rebuildSelectedLanguages(gatewayProvider.additionalData.subtitles)
          "
          (loginFieldsUpdated)="updateLoginField($event)"
          (generalFieldUpdated)="updateGeneralField($event)"
          (selectedSubtitlesChanged)="updateSubtitles($event)"
          (selectedLanguagesChanged)="updateLanguages($event)"
          (startTestConnnection)="startTestConnnection()"
          (providerStateUpdated)="updateIsActive($event)"
          (dropBucketFieldUpdated)="updateDropBucketField($event)"
        >
        </external-mam-providers-setup-step-one>
        <external-mam-providers-setup-step-two
          *ngSwitchCase="steps[1]"
          [mappedFields]="$any(gatewayProvider.additionalData.metadata)"
          [mappedOptions]="gatewayProviderMetadata"
          [referenceFields]="
            gatewayProvider.additionalData.referenceFields || []
          "
          (fieldMappingChange)="updateMetadataMapping($event)"
          (referenceFieldsChange)="updateReferenceFields($event)"
        >
        </external-mam-providers-setup-step-two>
      </ng-container>
    </div>
    <div class="emps-layout-buttons" *ngIf="gatewayProvider">
      <button
        *ngIf="currentStep != steps[0]"
        class="emps-layout-button"
        (click)="previousStep()"
      >
        <i class="icon-arrow-left"></i>
        <span>previous</span>
      </button>
      <button
        *ngIf="
          gatewayProvider.AbleToLogin() &&
          currentStep != steps[steps.length - 1]
        "
        class="emps-layout-button"
        (click)="nextStep()"
      >
        <span>next</span>
        <i class="icon-arrow-right"></i>
      </button>
      <button
        *ngIf="
          currentStep == steps[steps.length - 1] &&
          gatewayProvider.connectingTested() &&
          gatewayProviderMetadata
        "
        class="emps-layout-button"
        (click)="upsert()"
      >
        <span>submit</span>
      </button>
    </div>
  </div>
</div>
